document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-size-unit]');
  if (!button) return;
  const guide = button.closest('[data-satri-size-guide]');
  if (!guide) return;
  const inches = button.dataset.sizeUnit === 'in';
  guide.querySelectorAll('[data-size-unit]').forEach((item) => {
    const active = item === button;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-pressed', String(active));
  });
  guide.querySelectorAll('[data-cm], [data-cm-range]').forEach((cell) => {
    const values = (cell.dataset.cmRange || cell.dataset.cm).split(':');
    cell.textContent = inches
      ? values.map((cm) => (Number(cm) / 2.54).toFixed(1)).join('–')
      : values.join('–');
  });
});

/* FERONDO v3 CRO: on phones, a size chart that is still wider than the screen (product charts can have up to
   9 columns) is turned sideways: sizes become the columns and the measurements the rows. Turned back on wider
   screens. Cells are moved, not copied, so the CM / INCHES switch keeps working. */
(() => {
  const PHONE = window.matchMedia('(max-width: 749px)');
  const transpose = (table) => {
    if (table.querySelector('[colspan], [rowspan]')) return false;
    const grid = Array.from(table.rows).map((row) => Array.from(row.cells));
    if (grid.length < 2) return false;
    const cols = grid[0].length;
    if (grid.some((row) => row.length !== cols)) return false;
    const thead = document.createElement('thead');
    const tbody = document.createElement('tbody');
    for (let j = 0; j < cols; j++) {
      const tr = document.createElement('tr');
      for (let i = 0; i < grid.length; i++) {
        const cell = grid[i][j];
        if (cell.tagName === 'TH') {
          if (j === 0) cell.setAttribute('scope', 'col');
          else if (i === 0) cell.setAttribute('scope', 'row');
        }
        tr.appendChild(cell);
      }
      (j === 0 ? thead : tbody).appendChild(tr);
    }
    table.querySelectorAll(':scope > thead, :scope > tbody, :scope > tr').forEach((n) => n.remove());
    table.appendChild(thead);
    table.appendChild(tbody);
    if (table.hasAttribute('data-flipped')) table.removeAttribute('data-flipped');
    else table.setAttribute('data-flipped', '');
    return true;
  };
  const fit = (wrap) => {
    const table = wrap.querySelector('table');
    if (!table || !wrap.clientWidth) return;
    const flipped = table.hasAttribute('data-flipped');
    if (PHONE.matches) {
      if (flipped) return;
      const rows = table.rows.length;
      const cols = table.rows[0] ? table.rows[0].cells.length : 0;
      if (table.scrollWidth > wrap.clientWidth + 1 && rows < cols) transpose(table);
    } else if (flipped) {
      transpose(table);
    }
  };
  const ro = 'ResizeObserver' in window ? new ResizeObserver((entries) => entries.forEach((e) => fit(e.target))) : null;
  const init = () => {
    document.querySelectorAll('[data-satri-size-guide] .satri-size-modal__table-scroll').forEach((wrap) => {
      if (wrap.dataset.rzFit) return;
      wrap.dataset.rzFit = '1';
      if (ro) ro.observe(wrap);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('click', (event) => {
    if (event.target.closest && event.target.closest('.satri-size-guide-trigger, modal-opener')) {
      init();
      setTimeout(() => document.querySelectorAll('[data-satri-size-guide] .satri-size-modal__table-scroll').forEach(fit), 60);
    }
  });
})();
